<template lang="pug">
  v-container(fluid)
    v-card
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('labels.filters') }}
        v-spacer
        v-tooltip.ml-1.pointer(bottom)
          template(slot='activator')
            v-btn(flat @click="reset" icon)
              v-icon autorenew
          span Reset
        v-tooltip.ml-1.pointer(bottom)
          template(slot='activator')
            v-btn(flat @click="reloadData" icon)
              v-icon refresh
          span Fetch Data
      v-card-text
        v-layout(row wrap)
          v-flex(xs12)
            VueCtkDateTimePicker(v-model='setDate' label="Select Date Range" 
            range @input="setDateTime" overlay)
    v-card.mt-2
      v-toolbar.elevation-0(height="45" color="gray")
        v-toolbar-title
          h1.subheading {{ $t('pageHeader.signUps') }}
      v-card-title
        v-text-field(v-model='search', clearable prepend-icon='search', label='Search', single-line, hide-details)
      v-data-table(:headers='headers' :items='signups' :search="search" :loading='loading' :pagination.sync='pagination')
          template(slot='items' slot-scope='props')
            tr.pointer(@click="gotoPage(props.item)")
              td.text-xs-left {{ $moment(props.item.createdAt).format('M/D/YY hh:mm A') }}
              td.text-xs-left {{ props.item.firstName }}
              td.text-xs-left {{ props.item.lastName }}
              td.text-xs-left {{ props.item.companyName }}
              td.text-xs-left {{ props.item.phoneNumber | USPhoneNumber }}
              td.text-xs-left {{ props.item.email }}    
          v-alert(slot='no-results', :value='true', color='error', icon='warning')
            | Your search for "{{ search }}" found no results.
      

</template>

<script>
import locationService from "../service.js";
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      setDate: {
        start: this.$moment(new Date()).subtract(30, 'days').format("YYYY-MM-DD"),
        end: this.$moment(new Date()).format("YYYY-MM-DD")
      },
      filter: {
        fromDate: this.$moment(new Date()).subtract(30, 'days'),
        toDate: this.$moment(new Date())
      },
      headers: [
        {
          text: this.$t("labels.signUpAt"),
          value: "createdAt",
          sortable: true,
        },
        {
          text: this.$t("labels.firstName"),
          value: "firstName",
          sortable: true,
        },
        {
          text: this.$t("labels.lastName"),
          value: "lastName",
          sortable: true,
        },
        {
          text: this.$t("labels.companyName"),
          value: "companyName",
          sortable: true,
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "phoneNumber",
          sortable: true,
        },
        {
          text: this.$t("labels.email"),
          value: "email",
          sortable: true,
        }
      ],
      search: null,
      signups: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "id",
        descending: true
      }
    };
  },
  components: {
    VueCtkDateTimePicker
  },
  created() {
    this.getList()
  },
  methods: {
    gotoPage(data) {
      this.$router.push({ path: `/organization/profile/${data.organizationID}` })
    },
    setDateTime(val) {
      this.filter.fromDate = val.start
      this.filter.toDate = val.end
    },
    reset() {
      this.resetList()
      this.getList()
    },
    resetList() {
      this.filter.fromDate = this.$moment(new Date()).subtract(7, 'days')
      this.filter.toDate = this.$moment(new Date())
    },
    reloadData() {
      this.loading = true
      let proFilter = {}
      if (this.filter.fromDate)
        proFilter.fromDate = this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a")
      if (this.filter.toDate) 
        proFilter.toDate = this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      
      this.getList()
    },
    getList() {
      this.loading = true;
      let proFilter = {
        fromDate:this.$moment(this.filter.fromDate).format("MM/DD/YYYY h:m a"),
        toDate: this.$moment(this.filter.toDate).format("MM/DD/YYYY h:m a")
      }
      return locationService.getSignUp(proFilter).then(response => {
        this.signups = response.data;
        this.loading = false;
        return response;
      });
    },
    getListByStore() {
      this.loading = true;
      // console.log('this.location', this.location)
      return feedbackService.getById(this.location.storeID).then(response => {
        // console.debug("feedback with store id", response);
        this.feedback = response;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>

<style scoped>
.container.grid-list-lg .layout .flex {
    padding: 0px !important;
}
</style>